<div *ngIf="loading" class="loading-overlay">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>



<div class="container-fluid" style="padding-top: 7%;">
  <!-- Role Dropdown -->
  <div class="mb-3 col-md-6">
    <label for="roleSelect" class="form-label">Select Role</label>
    <select id="roleSelect" class="form-select" [(ngModel)]="selectedRole" (ngModelChange)="onRoleChange($event)"
      [ngClass]="{ 'green-border': selectedRole }">
      <option *ngFor="let role of roles" [ngValue]="role">
        {{ role.Role_Name }}
      </option>
    </select>
  </div>

  <!-- Questions -->
  <div class="row g-3 mt-4">
    <div class="col-12 col-md-6" *ngFor="let q of questions">
      <div class="card shadow-sm h-100">
        <!-- Card Header -->
        <div class="card-header bg-white d-flex justify-content-between align-items-center">
 
           <strong>Question: {{ q.QuestionText }}</strong>
          <div class="form-check form-switch m-0">
            <input class="form-check-input" type="checkbox" role="switch" [checked]="q.Status === 'Active'"
              [disabled]="isSaving[q.Id]" (change)="toggleQuestionStatus(q, $event)" />
            <label class="form-check-label">{{ q.Status }}</label>
          </div>
        </div>
        
        <!-- Card Body -->
        <div class="card-body">
        
          <div class="bg-light p-2 rounded small"
            [innerHTML]="q.Answer && q.Answer.trim() !== '' ? q.Answer : 'No answer yet'">
          </div>
        </div>
      </div>
    </div>
  </div>


  
</div>